import Alpine from 'alpinejs';
import KeenSlider from 'keen-slider';

Alpine.data('posts', (adminURL, lastPage) => ({
  items: '',
  cats: [],
  slider: null,
  isLoading: false,
  showDefault: true,
  page: 1,
  lastPage: +lastPage,

  init() {
    this.$watch('page', (value) => this.$dispatch('page-query', value));
  },

  setPage() {
    this.fetchPosts();
  },

  setFilter(e) {
    const cats = e.detail.by;
    this.cats = cats;
    this.page = 1;
    this.fetchPosts();
  },
  fetchPosts() {
    const formData = new FormData();
    formData.append('action', 'fetchPosts');
    formData.append('page', this.page);

    if (this.cats.length) formData.append('category_id', this.cats);

    fetch(adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.items = res.posts;
        this.lastPage = res.lastPage;
        this.showDefault = false;
      });
  },
}));
